// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Mandant, MandantDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateMandant(): (
  mandantId: string,
  requestBody: MandantDaten
) => Promise<Mandant> {
  const getAPI = useGetApi();
  return useCallback(
    async (mandantId, requestBody) =>
      (await getAPI()).mandanten.updateMandant({ mandantId, requestBody }),
    [getAPI]
  );
}
